import PropTypes from 'prop-types';
import React from 'react';
import MaskedInput from 'react-text-mask';
import IBANMaskChecker from '@afosto/utils/IBANMaskChecker';

const IBANMask = ({ inputRef, ...other }) => (
  <MaskedInput
    {...other}
    ref={ref => {
      inputRef(ref ? ref.inputElement : null);
    }}
    guide
    mask={IBANMaskChecker}
    placeholderChar="_"
    showMask={false}
    pipe={conformedValue => conformedValue.toUpperCase()}
  />
);

IBANMask.propTypes = {
  inputRef: PropTypes.func,
};

IBANMask.defaultProps = {
  inputRef: undefined,
};

export default IBANMask;
